// Services.js
import React from "react";

export default function Services() {
  return (
    <section className="section light">
      <div className="container">
        <h1 className="section-title">Our Services</h1>
        <p className="section-sub">
          Helping companies leverage engineering, cloud, and AI for measurable growth.
        </p>

        <div className="grid-3 cards">
          {/* Cloud Engineering */}
          <div className="card card-body center">
            <img src="/assets/lakehouse.png" alt="Cloud" className="icon-img" />
            <h3>Cloud Engineering</h3>
            <p>Modernize infrastructure and scale seamlessly.</p>
            <video autoPlay loop muted playsInline className="service-video">
              <source src="/assets/cleandata.mp4" type="video/mp4" />
              <img src="/assets/cleandata.png" alt="Cloud Demo" />
            </video>
          </div>

          {/* AI Solutions */}
          <div className="card card-body center">
            <img src="/assets/analytics.png" alt="AI" className="icon-img" />
            <h3>AI Solutions</h3>
            <p>Machine learning to transform business outcomes.</p>
            <video autoPlay loop muted playsInline className="service-video">
              <source src="/assets/insights.mp4" type="video/mp4" />
              <img src="/assets/insights.png" alt="AI Demo" />
            </video>
          </div>

          {/* DevOps */}
          <div className="card card-body center">
            <img src="/assets/metadata.png" alt="DevOps" className="icon-img" />
            <h3>DevOps & Automation</h3>
            <p>Ship faster, reduce risk, and innovate reliably.</p>
          </div>
        </div>
      </div>
    </section>
  );
}
